var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25C17.523 2.25 22 6.727 22 12.25C22 17.773 17.523 22.25 12 22.25C6.477 22.25 2 17.773 2 12.25C2 6.727 6.477 2.25 12 2.25ZM12 6.25C11.7348 6.25 11.4804 6.35536 11.2929 6.54289C11.1054 6.73043 11 6.98478 11 7.25V12.25C11.0001 12.5152 11.1055 12.7695 11.293 12.957L14.293 15.957C14.4816 16.1392 14.7342 16.24 14.9964 16.2377C15.2586 16.2354 15.5094 16.1302 15.6948 15.9448C15.8802 15.7594 15.9854 15.5086 15.9877 15.2464C15.99 14.9842 15.8892 14.7316 15.707 14.543L13 11.836V7.25C13 6.98478 12.8946 6.73043 12.7071 6.54289C12.5196 6.35536 12.2652 6.25 12 6.25Z",
    fill: "#F0BA0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.990eff7d74e4c38dc580656772fbbe6d.svg";
export { ForwardRef as ReactComponent };